export default __webpack_public_path__ + "static/media/IMG_20220618_122533_251.3d6e0c79.jpg";